import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useNavigate } from 'react-router-dom';

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Términos y Condiciones
            </h1>
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 bg-emerald-600 text-white px-6 py-3 rounded-lg hover:bg-emerald-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Volver al inicio
            </button>
          </div>
          <p className="text-gray-600 mb-12">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Aceptación de los Términos</h2>
              <p className="text-gray-700 leading-relaxed">
                Al acceder y utilizar este sitio web, usted acepta estar sujeto a estos términos y condiciones de uso, todas las leyes y regulaciones aplicables, y acepta que es responsable del cumplimiento de las leyes locales aplicables. Si no está de acuerdo con alguno de estos términos, tiene prohibido usar o acceder a este sitio.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Uso del Sitio Web</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                El usuario se compromete a utilizar el sitio web de conformidad con la ley, los presentes términos y condiciones, y cualquier otra normativa aplicable. En particular, el usuario se compromete a:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>No utilizar el sitio web con fines ilícitos o contrarios a la moral y buenas costumbres</li>
                <li>No introducir virus informáticos, archivos defectuosos o cualquier otro programa que pueda causar daños</li>
                <li>No intentar acceder a áreas restringidas del sitio web</li>
                <li>No reproducir, copiar, distribuir o modificar el contenido sin autorización previa</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Servicios Ofrecidos</h2>
              <p className="text-gray-700 leading-relaxed">
                PROTECPLUS INGENIERÍA ofrece servicios de protección contra incendios, ingeniería especializada, medición de gas radón, calibración e instalación de detectores de gases y formación profesional. Los detalles específicos de cada servicio, incluyendo precios, plazos y condiciones, se establecerán en el correspondiente contrato o presupuesto individual.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Presupuestos y Contratación</h2>
              <p className="text-gray-700 leading-relaxed">
                Los presupuestos proporcionados tienen una validez de 30 días desde su emisión, salvo que se indique lo contrario. La contratación de servicios se formalizará mediante la aceptación expresa del presupuesto y, en su caso, la firma del correspondiente contrato de prestación de servicios.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Precios y Pagos</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Los precios indicados en los presupuestos incluyen IVA, salvo que se indique lo contrario. Las condiciones de pago se establecerán en cada presupuesto o contrato específico. PROTECPLUS INGENIERÍA se reserva el derecho de:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Modificar los precios en cualquier momento, sin afectar a servicios ya contratados</li>
                <li>Suspender la prestación de servicios en caso de impago</li>
                <li>Aplicar intereses de demora según la legislación vigente</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Cancelaciones y Modificaciones</h2>
              <p className="text-gray-700 leading-relaxed">
                Las cancelaciones o modificaciones de servicios contratados deberán comunicarse por escrito con al menos 48 horas de antelación. Las cancelaciones realizadas con menor antelación podrán estar sujetas a penalizaciones según lo establecido en el contrato específico.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Responsabilidad</h2>
              <p className="text-gray-700 leading-relaxed">
                PROTECPLUS INGENIERÍA se compromete a prestar sus servicios con la máxima diligencia profesional y conforme a la normativa vigente. No obstante, no se responsabiliza de daños derivados de información incorrecta proporcionada por el cliente, caso fortuito, fuerza mayor o actuaciones de terceros.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Propiedad Intelectual</h2>
              <p className="text-gray-700 leading-relaxed">
                Todos los contenidos del sitio web, incluyendo textos, imágenes, logotipos, diseños y código fuente, son propiedad de PROTECPLUS INGENIERÍA o de terceros que han autorizado su uso, y están protegidos por las leyes de propiedad intelectual e industrial.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Enlaces a Terceros</h2>
              <p className="text-gray-700 leading-relaxed">
                Este sitio web puede contener enlaces a sitios web de terceros. PROTECPLUS INGENIERÍA no se hace responsable del contenido, políticas de privacidad o prácticas de estos sitios externos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Modificaciones</h2>
              <p className="text-gray-700 leading-relaxed">
                PROTECPLUS INGENIERÍA se reserva el derecho de modificar estos términos y condiciones en cualquier momento. Las modificaciones entrarán en vigor desde su publicación en el sitio web.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Legislación Aplicable y Jurisdicción</h2>
              <p className="text-gray-700 leading-relaxed">
                Estos términos y condiciones se rigen por la legislación española. Para la resolución de cualquier controversia, las partes se someten a los juzgados y tribunales de Madrid, renunciando expresamente a cualquier otro fuero que pudiera corresponderles.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
